/** Аватар игрока в купленной рамке.
 *
 * Рамку видят другие игроки в таблице рекордов — в этом её единственный
 * смысл, поэтому она рисуется и в магазине (примерка), и в списках.
 */

interface AvatarFrameProps {
  frame: string
  photoUrl: string
  name: string
  size?: number
}

export function AvatarFrame({ frame, photoUrl, name, size = 32 }: AvatarFrameProps) {
  return (
    <span
      className={`avatar avatar--${frame || 'none'}`}
      style={{ width: size, height: size }}
    >
      {photoUrl ? (
        <img className="avatar__image" src={photoUrl} alt="" loading="lazy" />
      ) : (
        // У игрока может не быть фотографии — первая буква имени лучше,
        // чем пустой кружок.
        <span className="avatar__letter">{name.trim().charAt(0) || '?'}</span>
      )}
    </span>
  )
}
